// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c9671352","239":"f2d256d0","453":"b1a5a552","667":"9f8729ae"}[chunkId] + ".chunk.js";
};